/* import __COLOCATED_TEMPLATE__ from './drawer-content.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';

interface DrawerContentArgs {
  hideManageConnectionButton?: boolean;
  routingAttributes?: string;
}
interface DrawerContentSignature {
  Args: DrawerContentArgs;
}

export default class DrawerContent extends Component<DrawerContentSignature> {
  @service declare session: Session;

  get appId() {
    return this.session.workspace.id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::HandoffToSalesforceInAppMessaging::DrawerContent': typeof DrawerContent;
    'workflows/graph-editor/node-items/steps/handoff-to-salesforce-in-app-messaging/drawer-content': typeof DrawerContent;
  }
}
